module.exports = __webpack_public_path__ + "media/images/icons/chart-d56c63cf7ca48959c133045d8f9c70ea.svg";